import HttpWrapper from '@/utils/http/httpWrapper'
import ShipbobAppSettings from '@/appSettings/appSetting'
const ONBOARDING_API = ShipbobAppSettings.onboardingApi

class OnboardingServiceInternal {
  urls () {
    return {
      stepState: `${ONBOARDING_API}/api/step/state`,
      stepEvent: `${ONBOARDING_API}/api/step/{stepId}/event/{eventId}`,
      stepEventBatch: `${ONBOARDING_API}/api/step/batch`,
      onboardingCheck: `${ONBOARDING_API}/api/exclusion/params/check`,
      onboardingVerify: `${ONBOARDING_API}/api/exclusion/params/check/validate`,
      getStartedSteps: `${ONBOARDING_API}/api/userSetup/GetStartedSteps`,
      getStartedSections: `${ONBOARDING_API}/api/userSetup/GetStartedSections`
    }
  }

  async getStartedSteps () {
    let request = {
      Url: this.urls().getStartedSteps
    }
    return await HttpWrapper.Get(request)
  }

  async getStartedSections () {
    let request = {
      Url: this.urls().getStartedSections
    }
    return await HttpWrapper.Get(request)
  }

  async fetchStepState () {
    const request = {
      Url: this.urls().stepState
    }
    return await HttpWrapper.Get(request)
  }

  async retryPost (request, retryCount = 0) {
    if (retryCount > 2) {
      return false
    }
    var success = await HttpWrapper.Post(request)
    if (success === false) {
      await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)))
      success = await this.retryPost(request, retryCount + 1)
    }
    return success
  }

  async postStepEvent (stepId, eventId, eventValue) {
    const request = {
      Url: this.urls().stepEvent.replace('{stepId}', stepId).replace('{eventId}', eventId),
      Data: {
        EventValue: eventValue
      }
    }
    return await this.retryPost(request)
  }

  async postStepEventBatch (data) {
    const request = {
      Url: this.urls().stepEventBatch,
      Data: data
    }
    return await this.retryPost(request)
  }

  async checkOnboardingParams (query) {
    const request = {
      Url: this.urls().onboardingCheck,
      Params: query
    }
    return await HttpWrapper.Get(request)
  }

  async verifyOnboardingParams (query) {
    const request = {
      Url: this.urls().onboardingVerify,
      Params: query
    }
    return await HttpWrapper.Get(request)
  }
}

export const OnboardingService = new OnboardingServiceInternal()
